/*
 * @FilePath     : /es-package/packages/es-mpx-bridge/lib/payment/index.web.js
 * @Author       : LiYang
 * @Date         : 2021-11-04 19:45:47
 * @LastEditTime: 2022-12-22 18:46:07
 * @LastEditors: showangjing showangjing@didiglobal.com
 * @Description  :
 */

import { pay as webxPay } from '@didi/webx-js-web';
import { getWXAppid } from '../../utils';

// 支付
export function pay({ out_trade_id, token, yks_appid }) {
  console.log('---------------payin appid is---------------', getWXAppid());
  const payOptions = {
    token: token,
    // open_id: '',
    out_trade_id: out_trade_id,
    appid: getWXAppid(),
  };
  // 机火独小未接入赤兔，需要增加环境标识
  if (yks_appid && ['121735', '2021004166617541'].includes(yks_appid)) {
    payOptions['tc_terminal'] = '111-41801-000'
  }
  return webxPay({
    pay: payOptions,
  })
}

export default {
  pay,
  // pay: payment,
  destroy: () => getApi().then((DpayWeb) => DpayWeb.default.destroy()),
  close: () => getApi().then((DpayWeb) => DpayWeb.default.close()),
};
